import React, { forwardRef } from "react";

interface CheckboxProps
  extends Omit<React.InputHTMLAttributes<HTMLInputElement>, "type"> {
  label: string | JSX.Element;
}

const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(
  ({ id, name, label, ...props }, ref) => {
    return (
      <div className="flex items-center">
        <input
          ref={ref}
          id={id}
          name={name}
          type="checkbox"
          className="h-4 w-4 rounded border-content-300 bg-white text-primary-600 focus:ring-primary-500 dark:border-content-700 dark:bg-content-900 dark:text-primary-400 dark:focus:ring-primary-400"
          {...props}
        />
        <label
          htmlFor={id}
          className="ml-2 block text-sm text-content-900 dark:text-content-200"
        >
          {label}
        </label>
      </div>
    );
  }
);

Checkbox.displayName = "Checkbox";

export default Checkbox;
